import { motion } from "framer-motion";

import SectionHead from "./SectionHead";
import { features } from "../data/features";
import { revealContainer, fadeUp } from "../lib/motionVariants";

export default function Features() {
  return (
    <motion.section
      id="features"
      variants={revealContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
      className="pb-7 pt-10 md:pb-12 md:pt-[88px]"
    >
      <motion.div variants={fadeUp}>
        <SectionHead num="01" title="WHAT YOU GET" meta="Eight modules" />
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {features.map(({ Icon, title, desc }) => (
          <motion.article
            key={title}
            variants={fadeUp}
            className="group flex items-start gap-[18px] border-b border-border py-7 pr-7 transition-colors duration-200 hover:border-ink"
          >
            <Icon aria-hidden="true" className="mt-[3px] h-[26px] w-[26px] flex-none text-ink transition-colors duration-200 group-hover:text-primary" />
            <div>
              <h3 className="mb-2.5 font-mono text-xs uppercase tracking-[0.16em] transition-colors duration-200 group-hover:text-primary">{title}</h3>
              <p className="max-w-[40ch] text-[17px] leading-snug text-ink-600">{desc}</p>
            </div>
          </motion.article>
        ))}
      </div>
    </motion.section>
  );
}
